module.exports = __webpack_public_path__ + "dbb92d42ab5737a093924db9de8c2f3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/address-info/icon-mail.png
// module id = ./src/components/address-info/icon-mail.png
// module chunks = index